<template>
    <div style="overflow-x: hidden; background: #ededee;" class="h-100">
      <template v-if="loading">
        <div id="wrapper_loading"><b-img class="align-self-center" src="@/assets/comprovei_anim_loop2.0.svg" fluid></b-img></div>
      </template>
      <template v-else>
        <template v-if="errored">
          <NotFound />
        </template>
        <template v-else>
          <div class="row h-100" style="background: #ededee;">
            <template v-if="(this.info.data.documentInfo.status_stop_id == 1 || this.info.data.documentInfo.status_stop_id == 2) && this.info.data.documentInfo.display_map == 1">          
              <div class="p-0 column">
                <TopBar v-bind:data="this.info.data"/>
                <Sidebar v-bind:info="this.info"/>
              </div>
              <div class="p-0 column">
                <Map v-bind:info="this.info" />
              </div>
            </template>
            <template v-else>
              <TopBar v-bind:data="this.info.data"/>
              <Sidebar v-bind:info="this.info"/>
            </template>
          </div>
        </template>
      </template>
    </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import Map from './Map.vue'
import NotFound from './NotFound.vue'
import TopBar from './TopBar.vue'

export default {
  name: 'home',
  components: {
    Sidebar,
    Map,
    NotFound,
    TopBar
  },
   data () {
    return {
      info: null,
      errored: false,
      loading: true
    }
  },
  mounted() {
    var req = {
        searchKey: this.$route.params.searchKey
    }

    this.axios.post('https://document-tracking-api.comprovei.com/v1/documents', req, { headers: { "x-api-key":"9Ng5JgOCpg9gJAuUULmCf6FUQAdWVrP54mMuZ4RD" }})
    .then(response => {
        this.info = response
    })
    .catch(error => {
        this.errored = true
    })
    .finally(() => this.loading = false)
  }
}
</script>

<style>
html, body{
  height: 100%;
  margin: 0;
  overflow: auto;
  color: #495057 !important;
  background: #ededee;

  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#wrapper_loading{
  width: 100%;
  height: 100%;
  display: flex;
}

#wrapper_loading img{
  margin: auto;
  max-height: 200px;
}

.card{
    box-shadow: 0 0.46875rem 2.1875rem rgba(4,9,20,0.03), 0 0.9375rem 1.40625rem rgba(4,9,20,0.03), 0 0.25rem 0.53125rem rgba(4,9,20,0.05), 0 0.125rem 0.1875rem rgba(4,9,20,0.03);
    border-width: 0;
    transition: all .2s;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

* {
  box-sizing: border-box;
}

.column {
  float: left;
  width: 50%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

@media screen and (max-width: 480px) {
  .column {
    width: 100%;
  }
}

</style>